var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"about__hero py-3 p-lg-5 w-100"}),_c('div',{staticClass:"container my-3 my-lg-5 py-lg-5"},[_c('bucp'),_c('partners')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }